import defaultDeep from 'lodash/defaultsDeep';
import SessionStorage from '~/services/SessionStorage';
import { allowedFilterKeys } from '../skillsConstants';
import { PAGE_SIZE } from '../constants';

export const DISCOVERY_FILTER_FILTERS_KEY = 'qz/discovery_filter_filters';
export const DISCOVERY_FILTER_TYPE_KEY = 'qz/discovery_filter_type';

export function getLiteraturePayload(values?: any) {
  return defaultDeep(values, {
    from: 0,
    size: 12,
    source: 'literature',
    internal: true,
    filters: {},
    queryId: SessionStorage.getItem('queryId'),
    sortBy: {
      key: '_score',
      order: 'desc',
    },
    includeCollections: false,
    page: '',
  });
}

const defaultSkillsPayload = {
  from: 0,
  size: PAGE_SIZE,
  source: 'skills-discovery',
  internal: true,
  filters: {},
  queryId: '',
  sortBy: {
    key: '_score',
    order: 'desc',
  },
  includeCollections: false,
  page: '',
  queryTermOverride: '',
  nodesToInclude: [] as string[],
};

export function getSkillsPayload(values?: Partial<typeof defaultSkillsPayload>) {
  return defaultDeep(values, defaultSkillsPayload);
}

export function getSkillsFilterObj(filters: Record<string, any>) {
  return allowedFilterKeys.reduce((acc, key) => {
    if (filters[key]) {
      acc[key] = filters[key];
    }
    return acc;
  }, {} as Record<string, any>);
}

interface Schema {
  id: string,
  name: string,
  label: string,
}
export function getInitialNodes(skillFilterSchema: Schema[] | null, filterType: string) {
  const typeInSession = JSON.parse(sessionStorage.getItem(DISCOVERY_FILTER_TYPE_KEY) ?? '""');
  const topicsIdsInSession = JSON.parse(sessionStorage.getItem(DISCOVERY_FILTER_FILTERS_KEY) ?? '[]'); ;
  const selectedNodes = [] as string[];

  if (typeInSession === filterType) {
    topicsIdsInSession.forEach((id: string) => {
      const node = skillFilterSchema?.find(node => node.id === id);
      if (node) {
        selectedNodes.push(id);
      }
    });
  }

  return selectedNodes;
}

export function getNodesToInclude(nodes: string[]) {
  return nodes.map((id: string) => `skillNode|${id}`);
}
